"use strict";

Object.defineProperty(exports, "__esModule", {
    value: true
});
var bedTypeValues = {
    1: "Twin",
    2: "Matrimonial"
    // Do not change this as this could break things, those are values
    // Sent via the API, the backend/ API expects this literal string
};

exports.default = bedTypeValues;
module.exports = exports["default"];


//////////////////
// WEBPACK FOOTER
// ./app/metadata/forms/formOptions/bed_type/bedTypeValues.js
// module id = 1367
// module chunks = 0